document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
      var section = document.querySelector(".blur-on-scroll");
      if (section) {
          if (window.scrollY > 100) { 
              section.classList.add("scrolled");
          } else {
              section.classList.remove("scrolled");
          }
      }
  });
});